import { Permission, PermissionEnum } from '../../../types';

const ALL_PERMISSIONS: Permission[] = Object.values(PermissionEnum);

export function PermissionCheckboxes({
  value,
  onChange,
}: {
  value: string[];
  onChange: (v: string[]) => void;
}) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {ALL_PERMISSIONS.map((p) => (
        <label key={p} className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-border accent-primary"
            checked={value.includes(p)}
            onChange={(e) =>
              onChange(e.target.checked ? [...value, p] : value.filter((x) => x !== p))
            }
          />
          <span className="text-sm">{p.replace(/_/g, ' ')}</span>
        </label>
      ))}
    </div>
  );
}
